import type { ProactiveGreetingQuickReply } from '@teo/widget-shared';

type QuickReplyButtonsProps = {
  quickReplies: ProactiveGreetingQuickReply[];
  onSelect: (quickReply: ProactiveGreetingQuickReply) => void;
  variant?: 'launcher' | 'popup';
};

export function QuickReplyButtons({
  quickReplies,
  onSelect,
  variant = 'launcher',
}: QuickReplyButtonsProps) {
  const isSingle = quickReplies.length === 1;

  return (
    <div
      className={`teo-quick-replies teo-quick-replies--${variant}${
        isSingle ? ' teo-quick-replies--single' : ''
      }`}
      role="group"
      aria-label="Quick replies"
    >
      {quickReplies.map((quickReply) => (
        <button
          key={quickReply.id ?? `${quickReply.label}:${quickReply.message}`}
          type="button"
          className="teo-quick-replies__button"
          onClick={() => onSelect(quickReply)}
        >
          {quickReply.label}
        </button>
      ))}
    </div>
  );
}
